<script lang="ts">
</script>

<div class="fizz-center-content fizz-inset-vertical-48">
  <div class="fizz-heading-1 fizz-stack-24">Oops! Something's not right.</div>
  <div>We couldn't match your Spec's account.</div>
  <div>Please contact your Spec's sales rep.</div>
</div>
